import el from '@finn-no/create-element';

export default {
    dependencies: ['$element', 'employerprofileservice', 'trackingservice'],
    callable(ele, employerProfileService, trackingService) {
        const MODE = {
            RECOMMENDED: 0,
            RANDOM: 1,
        };

        function createEventCategory(mode, event) {
            return `${mode === MODE.RECOMMENDED
                ? 'recommend'
                : 'random'}-employer.m-job-front.${event}`;
        }

        function trackClicked(mode) {
            trackingService.trackLaterObj({
                ecType: 'USER',
                ecCategory: createEventCategory(mode, 'click'),
            });
        }

        function renderRecommendations({ profiles, mode }) {
            ele.appendChild(
                el(
                    'div.mod.shadow',
                    null,
                    el(
                        'div.inner.pvn',
                        null,
                        el(
                            'div.bd',
                            null,
                            el(
                                'h3.d1.strong.fixedfontsize',
                                null,
                                `${mode === MODE.RECOMMENDED
                                    ? 'Anbefalte'
                                    : 'Utvalgte'} bedriftsprofiler`
                            ),
                            el(
                                'div.line.r-cols1to3.r-mhm.r-hide-last-element.r-mbm',
                                null,
                                profiles
                                    .slice(0, 3)
                                    .map(
                                        ({
                                            href,
                                            imagePath,
                                            logo,
                                            companyName,
                                        }) =>
                                            el(
                                                'div.unit.r-size1of3',
                                                null,
                                                el(
                                                    'a.linkblock.licorice.blockify.r-mhm.mtn.mbl',
                                                    {
                                                        href,
                                                        onclick() {
                                                            trackClicked(mode);
                                                        },
                                                    },
                                                    el(
                                                        'div.format4by3',
                                                        null,
                                                        el(
                                                            'img.centered-image',
                                                            {
                                                                src: `https://images.finncdn.no/dynamic/480x360c/${imagePath}`,
                                                                srcset: `https://images.finncdn.no/dynamic/480x360c/${imagePath} 480w,
                                                 https://images.finncdn.no/dynamic/240x180c/${imagePath} 240w,
                                                 https://images.finncdn.no/dynamic/320x240c/${imagePath} 320w,
                                                 https://images.finncdn.no/dynamic/640x480c/${imagePath} 640w,
                                                 https://images.finncdn.no/dynamic/960x720c/${imagePath} 960w`,
                                                                sizes:
                                                                    '(min-width: 990px) 300px, (min-width: 768px) 33vw, (min-width: 480px) 50vw',
                                                                alt: '',
                                                            }
                                                        )
                                                    ),
                                                    el(
                                                        'span.r-mhm.r-mtm.mbt.blockify',
                                                        null,
                                                        el('img.fright', {
                                                            src: logo,
                                                            style:
                                                                'max-height: 40px; max-width: 60px;',
                                                            alt: '',
                                                        }),
                                                        el(
                                                            'span.truncate.primary-blue.blockify.t4',
                                                            null,
                                                            companyName
                                                        )
                                                    )
                                                )
                                            )
                                    )
                            )
                        )
                    )
                )
            );
        }

        employerProfileService
            .getRecommended()
            .then(profiles => {
                if (profiles.length === 0) {
                    return employerProfileService
                        .getRandom()
                        .then(profiles => ({ profiles, mode: MODE.RANDOM }));
                } else {
                    return { profiles, mode: MODE.RECOMMENDED };
                }
            })
            .then(({ profiles, mode }) => {
                if (profiles.length > 0) {
                    renderRecommendations({ profiles, mode });
                    trackingService.trackEventObject({
                        ecType: 'USER',
                        ecCategory: createEventCategory(mode, 'impression'),
                    });
                }
            });
    },
};



// WEBPACK FOOTER //
// ./controllers/employerProfileRecommendations.js